import block from "./block.js";
import component from "./components/index.js"
import containerDifferences6 from "./components/containerDifferences6.js";
export default (editor, opts = {}) => {
    //components
  editor.DomComponents.addType("containerDifferences6", containerDifferences6(opts));
  editor.DomComponents.addType("differences6", component(opts));
    //block
  editor.BlockManager.add("differences6", block(opts));
};